"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDescriptionConfig = exports.defaultTitleConfig = void 0;
var defaultTitleConfig = {
    size: 3,
    margin: {
        desktop: '0 0 20px',
        tablet: '0 0 20px',
        mobile: '0 0 20px'
    }
};
exports.defaultTitleConfig = defaultTitleConfig;
var defaultDescriptionConfig = {
    align: 'center',
    margin: {
        desktop: '0 0 30px',
        tablet: '0 0 30px',
        mobile: '0 0 30px'
    }
};
exports.defaultDescriptionConfig = defaultDescriptionConfig;
//# sourceMappingURL=BeforeYouGo.js.map